import * as yup from 'yup';

export const translationBasePath = '_DASHBOARD._MANAGE_INSTITUTIONS_USERS';

export const validationSchema = (t) =>
  yup.object({
    userId: yup.number().required(t(`${translationBasePath}._FIELD_REQUIRED`)),
    role: yup.string().required(t(`${translationBasePath}._ROLE_REQUIRED`)),
  });
